import React, { useEffect, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { useSplitPriceList } from '../../../../../hooks/experiments';

const PriceListSplitExperiment: React.FC<IPriceListSplitExperimentProps> = props => {
  const mobilePhoneCategoryId = '103';
  const { market } = useContext(AppContext);

  return props.categoryId === mobilePhoneCategoryId || market.code === 'gb' ? (
    <Experiment setSplitList={props.setSplitList} />
  ) : null;
};

const Experiment: React.FC<IExperimentProps> = props => {
  const splitListExperiment = useSplitPriceList();
  const { setSplitList } = props;

  useEffect(() => {
    setSplitList(splitListExperiment);
  }, [splitListExperiment, setSplitList]);

  return <></>;
};

interface IPriceListSplitExperimentProps {
  setSplitList: React.Dispatch<React.SetStateAction<boolean>>;
  categoryId: string | undefined;
}

interface IExperimentProps {
  setSplitList: React.Dispatch<React.SetStateAction<boolean>>;
}

export default PriceListSplitExperiment;
